import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function StaffMembers() {
  useEffect(() => {
    document.title = "Staff Members-  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>About Us</li>
                <li>Staff Members</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Staff Members</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <h5>Pre-Primary/Primary</h5>

              <ul className="mainlist">
                <li>Mrs. Sapana Ningombam Devi</li>
                <li>Mrs. Samita Chaudhary</li>
                <li>Mrs. Versha Chauhan</li>
                <li>Mrs. Pooja Yadav</li>
                <li>Mrs. Seema Singh Mann</li>
                <li>Mrs. Vinita Yadav</li>
                <li>Mrs. Meenakshi Dhama</li>
                <li>Mrs. Anita Rani</li>
                <li>Mr. Ravi Ranjan</li>
                <li>Kiran Tomar</li>
                <li>K S Swathy</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <h5>Non Teaching Staff</h5>

              <ul className="mainlist">
                <li> Mrs. Suman </li>
                <li> Mr. Sumit</li>
              </ul>
              <h5>Support Staff:</h5>
              <ul className="mainlist">
                <li> Mrs. Lusiya Burh </li>
                <li> Mrs. Edlim Kandulna </li>
                <li> Mrs. Sarita Kerketta </li>
                <li> Mr. John Kalyan Ekka </li>
                <li> Mr. Jirthius Kujur </li>
                <li> Mr. Mahajan Tirkey </li>
                <li> Mr. Ammar Dhami </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StaffMembers;
